import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref, computed, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { queryContractDetail, contractCodeUpdate } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'
import { DcMessage } from '@dc-platform/dc-components'
import type { ContractItem } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'
const __default__ = { name: 'tabsContract ' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  returnName: String
},
  setup(__props) {

const { t } = useI18n()
const route = useRoute()

const visible = ref(false)
const formRef = ref()
const loading = ref(false)
const editForm = ref<ContractItem>({})
const data = ref<ContractItem[]>([])
const columns = computed(() => [
  { title: t('contract.customerName'), dataIndex: 'customerName' },
  { title: t('contract.arkCode'), dataIndex: 'arkCode' },
  { title: t('contract.id'), dataIndex: 'id' },
  { title: t('contract.contractCode'), dataIndex: 'contractCode' },
  { title: t('contract.contractBusiness'), dataIndex: 'contractBusiness' },
  {
    title: t('contract.serviceSubject'),
    dataIndex: 'serviceSubject',
    node: 'ParamCodesSelect',
    attrs: {
      paramCode: 'ofbu_service_body',
      appId: 'cos_ofbu',
      view: true
    }
  },
  { title: t('contract.contractType'), dataIndex: 'contractType' },
  { title: t('contract.offlineSyncTime'), dataIndex: 'offlineSyncTime' },
  { title: t('contract.businessThirdCate'), dataIndex: 'businessThirdCate' },
  { title: t('contract.contactName'), dataIndex: 'contactName' },
  { title: t('contract.contactMobile'), dataIndex: 'contactMobile' },
  { title: t('contract.contactEmail'), dataIndex: 'contactEmail' },
  { title: t('contract.counterpartContactName'), dataIndex: 'counterpartContactName' },
  { title: t('contract.counterpartContactMobile'), dataIndex: 'counterpartContactMobile' },
  { title: t('contract.counterpartContactEmail'), dataIndex: 'counterpartContactEmail' },
  { title: t('contract.seller'), dataIndex: 'seller' },
  { title: t('contract.contractSeller'), dataIndex: 'contractSeller' },
  { title: t('contract.contractTime'), dataIndex: 'contractTime' },
  { title: t('contract.counterpartContractTime'), dataIndex: 'counterpartContractTime' },
  { title: t('contract.contractCreateTime'), dataIndex: 'contractCreateTime' }
])
const fetch = () => {
  if (route.query.cosId || route.query.arkCode) {
    queryContractDetail({
      arkCode: route.query.arkCode,
      cosId: route.query.cosId
    }).then((res) => {
      data.value = res.data
    })
  }
}
const viewPdf = (data: ContractItem) => {
  if (data.fileUrl) {
    const eleLink = document.createElement('a')
    eleLink.download = data.fileUrl
    eleLink.style.display = 'none'
    eleLink.href = data.fileUrl
    document.body.appendChild(eleLink)
    eleLink.click()
    document.body.removeChild(eleLink)
  } else {
    DcMessage.warning(t('tips.noContract'))
  }
}
// 修改合同编码
const showEditModal = (data: ContractItem) => {
  editForm.value = {
    ...data,
    newContractCode: undefined
  }
  visible.value = true
}
const updateCode = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { id, newContractCode } = editForm.value
    contractCodeUpdate({
      id,
      contractCode: newContractCode
    })
      .then((res) => {
        visible.value = false
        DcMessage.success(t('tips.K9PBK8'))
        fetch()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(DetailCard), {
            key: index,
            columns: columns.value,
            title: `${_unref(t)('contract.concatMessage')}${index + 1}`,
            data: item
          }, {
            subTitle: _withCtx(() => [
              _createVNode(_component_dc_layout_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: ($event: any) => (viewPdf(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.originalpreview')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (showEditModal(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.changeContractCode')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["columns", "title", "data"]))
        }), 128)),
        (!data.value || !data.value.length)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_cos_footer_button, {
      loading: loading.value,
      returnName: __props.returnName,
      hideOk: true
    }, null, 8, ["loading", "returnName"]),
    _createVNode(_component_cos_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      title: _unref(t)('contract.changeContractCodeModalTitle'),
      width: "470px",
      onOk: updateCode,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: editForm.value,
              ref_key: "formRef",
              ref: formRef,
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "contractCode",
                  label: _unref(t)('contract.oldConcatCode'),
                  rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: editForm.value.contractCode,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.contractCode) = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]),
                _createVNode(_component_a_form_item, {
                  name: "newContractCode",
                  label: _unref(t)('contract.newConcatCode'),
                  rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: editForm.value.newContractCode,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.newContractCode) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "confirmLoading"])
  ], 64))
}
}

})